<template>
    <div>
            <div class="row">
                <div class="div-alerta hide" role="alert" style="margin-top: 25px;background-color: #fcf8e3; color: #8a6d3b;padding-right: 35px;padding: 15px;margin-bottom: 20px;border: 1px solid #faebcc;border-radius: 4px; text-align: center">
                    <strong>Atenção!</strong> Uma nova página será aberta para processar o download.
                </div>
                <div class="msg-success hide" style="color: #00aa00; margin-bottom: 14px; float: right;">E-mail enviado com sucesso</div>
            </div>

            <c-busca :fieldsProp="fieldsBusca" @changeFiltros="changeFiltros"></c-busca>

            <div class="row">

                <v-lt-fotos ref="listagem"></v-lt-fotos>

            </div>

        <vue-element-loading :active="loading" is-full-screen></vue-element-loading>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import formatMixin from '../../../../../../../../../resources/assets/js/mixins/formatMixin';

    export default {
        mixins: [formatMixin],
        props:{
            id: Number
        },
        data(){
          return {
              loading: false,
              fieldsBusca: [
                  {name: 'referencia',  type: 'text',   label: 'Referência',          class: 'column-3', value: ''},
                  {name: 'nome',        type: 'text',   label: 'Nome',                class: 'column-3', value: ''},
                  {name: 'descricao',   type: 'text',   label: 'Descrição',           class: 'column-4', value: ''},
              ]
          }
        },
        methods:{
            changeFiltros(filtros) {
                this.$refs.listagem.buscar(Object.assign({}, ...filtros));
            }
        }
    };
</script>